import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { toLocaleDateTime } from 'src/common/utils/dateUtils';

const offset = 1000 * 10;

const updateTime = () => {
  const now = new Date();
  const formattedDate = toLocaleDateTime(now);

  const offset = now.getTimezoneOffset();
  const offsetHours = -offset / 60;
  const sign = offsetHours >= 0 ? '+' : '-';

  const formattedDateWithOffset = `${formattedDate} (UTC ${sign} ${Math.abs(offsetHours)})`;

  return formattedDateWithOffset;
};

export const AppTimer = () => {
  const [currentDate, setCurrentDate] = useState(updateTime);

  useEffect(() => {
    const intervalId = setInterval(() => setCurrentDate(updateTime()), offset);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <Typography variant="text4" component="div" data-testid="app-timer" color="text.secondary">
      {currentDate}
    </Typography>
  );
};
